export const FEES_WITHDRAWING_TOKEN_START = 'FEES_WITHDRAWING_TOKEN_START';
export const FEES_WITHDRAWING_ETHER_START = 'FEES_WITHDRAWING_ETHER_START';
export const FEES_WITHDRAWING_TOKEN_END = 'FEES_WITHDRAWING_TOKEN_END';
export const FEES_WITHDRAWING_ETHER_END = 'FEES_WITHDRAWING_ETHER_END';

export interface FeesWithdrawingTokenStart {
  type: typeof FEES_WITHDRAWING_TOKEN_START;
}

export interface FeesWithdrawingEtherStart {
  type: typeof FEES_WITHDRAWING_ETHER_START;
}

export interface FeesWithdrawingTokenEnd {
  type: typeof FEES_WITHDRAWING_TOKEN_END;
}

export interface FeesWithdrawingEtherEnd {
  type: typeof FEES_WITHDRAWING_ETHER_END;
}

export type FeesActionTypes =
  | FeesWithdrawingTokenStart
  | FeesWithdrawingEtherStart
  | FeesWithdrawingTokenEnd
  | FeesWithdrawingEtherEnd;
